export default {
  welcome: 'مرحبا',
  beeText1: 'بزز... هل تريد مني مساعدتك في إنشاء بعض المهام؟',
  beeText2: 'ألق نظرة على حقل النص أدناه. سيعطيك بعض التلميحات حول كيفية البدء',
  beeText3: 'بزز... أنا نحلة مشغولة، لكن يمكنني مساعدتك في إنشاء بعض المهام',
  task: 'المهمة',
  taskExample1: 'تنظيف الحمام',
  taskExample2: 'تحضير الوجبات',
  taskExample3: 'الذهاب إلى السوبرماركت',
  taskExample4: 'غسيل الملابس',
}
